/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CourierItem } from './courier_item'
import type { DeliveryItem } from './delivery_item'
/**
 * Информация о приезде курьера
 */
export type CourierDeliveryInfo = {
  /**
   * Тип точки маршрута заявки
   */
  pointType: CourierDeliveryInfo.pointType
  /**
   * Информация о курьере
   */
  courier?: CourierItem
  /**
   * Информация о приезде к клиенту
   */
  delivery?: DeliveryItem
  /**
   * Дата и время назначения/отмены курьера
   */
  createDatetime: string
}
export namespace CourierDeliveryInfo {
  /**
   * Тип точки маршрута заявки
   */
  export enum pointType {
    DEPARTURE = 'departure',
    DESTINATION = 'destination'
  }
}
